<template>
  <span :class="$style.root">
    <span :class="$style.progressBar" :style="progressBarStyle" />
  </span>
</template>

<script>

import percent from '@converdy/utils/percent'

import defaultRootComponent from '../defaultRootComponent'

export default {
  name: 'ProgressBar',

  mixins: [ defaultRootComponent('span') ],

  props: {
    max: Number,
    progress: Number
  },

  computed: {
    progressBarStyle () {
      return {
        width: `${percent(this.max, this.progress)}%`
      }
    }
  }
}

</script>

<style module>

.root {
  display: inline-block;
  position: relative;
  height: 3px;
  width: 100%;

  @apply bg-dull;
}

.progressBar {
  display: inline-block;
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;

  @apply bg-primary;
}

</style>
